import {
    Chart as ChartJS,
    BarElement,
    PointElement,
    LineElement,
    BarController,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title
} from 'chart.js';

import {
    BoxPlotController,
    BoxAndWiskers
} from '@sgratzl/chartjs-chart-boxplot';

ChartJS.register(
    BarElement,
    PointElement,
    LineElement,
    BarController,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
    BoxPlotController,
    BoxAndWiskers
);

ChartJS.defaults.color = '#2E3639';
ChartJS.defaults.font.family = "'Source Sans Pro', sans-serif";
ChartJS.defaults.font.size = 14;